const axios = require("axios").default;
const React = require("react");
const ReactDOMClient = require("react-dom/client");

function renderComponent(Component, containerId) {
  const container = document.getElementById(containerId);
  if (!container) return;

  const root = ReactDOMClient.createRoot(container);
  root.render(React.createElement(Component));
}

function incrementCartCount() {
  var cartIcon = document.getElementById("cartIcon");
  if (cartIcon) {
    var count = Number(cartIcon.getAttribute("value"));
    if (isNaN(count)) {
      count = 0;
    }

    if (count === 0) {
      cartIcon.classList.remove("no-after");
    }

    cartIcon.setAttribute("value", count + 1);
  }
}

function decrementCartCount() {
  var cartIcon = document.getElementById("cartIcon");
  if (cartIcon) {
    var count = Number(cartIcon.getAttribute("value"));
    var newCount = count - 1;
    if (newCount === 0) {
      newCount = "";
      cartIcon.classList.add("no-after");
    }
    cartIcon.setAttribute("value", newCount);
  }
}

function setCartValue(value) {
  var cartIcon = document.getElementById("cartIcon");
  if (cartIcon) {
    cartIcon.setAttribute("value", value);

    if (!value) cartIcon.classList.add("no-after");
    else cartIcon.classList.remove("no-after");
  }
}

function currencyFormat(num) {
  if (!num) num = 0;
  return "$" + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}

async function logError(error, logTitle = "") {
  await axios.post("/Services/Events/Log", {
    Error: error.toString(),
    UserAgent: window.navigator.userAgent,
    LogTitle: logTitle,
  });
}

function convertDate(date) {
  if (date) {
    if (Number.isInteger(date)) {
      return new Date(date).toLocaleDateString();
    }

    if (date.startsWith("/Date(")) {
      let dateNum = date.replace("/Date(", "").replace(")/", "");
      return new Date(parseInt(dateNum)).toLocaleDateString();
    }

    if (date.includes("T")) {
      let parsedDate = new Date(date);
      let month = parsedDate.getMonth() + 1;
      let day = parsedDate.getDate();
      let year = parsedDate.getFullYear();

      return `${month}/${day}/${year}`;
    }

    return "";
  }
  return "";
}

module.exports = {
  renderComponent: renderComponent,
  convertDate: convertDate,
  incrementCartCount: incrementCartCount,
  decrementCartCount: decrementCartCount,
  setCartValue: setCartValue,
  currencyFormat: currencyFormat,
  logError: logError,
};
